import { defineMessages } from 'react-intl-next';
export var filterOptionMessages = defineMessages({
  assigneeUnassignedFilterOption: {
    id: 'linkDataSource.basic-filter.dropdown.select.assignee.unassigned',
    description: 'Text to display for Unassigned assignee filter option.',
    defaultMessage: 'Unassigned'
  }
});